/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect } from "react";
import { useParams,Link } from 'react-router-dom';
import axios from "axios";
import "react-datepicker/dist/react-datepicker.css";

import HeaderTitle from "../../components/includes/HeaderTitle";
import { isObjEmpty,ChangeDateStringOnlyDate, unescapeHtml } from "../../../components/common/Common";

/* css */
import "../../../css/admin_layout.css";
import "../../../css/admin.css";

const StaffReportDetail = ({setMenuType,setMenuItem}) => {
  let { sr_idx } = useParams();

  //회원정보
  const [varStaffReportInfo,setStaffReportInfo] = useState({});

  //회원정보 읽어오기
  const getStaffReportInformation = async () => {
    const sendData = {sr_idx:sr_idx};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/admin_get_staff_report_information`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      if(datas.retvalue === 1) {
        if(datas.results?.length > 0){
          let dataInfo = datas.results[0];
          setStaffReportInfo(dataInfo);
        }
      }
    });
  }

  //페이지 정보 표시 - 최초
  useEffect(() => {
    setMenuType('MEMBER');
    setMenuItem('StaffReportList');
    getStaffReportInformation();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div id="admin_contents" className="ad_contents">
      <HeaderTitle varMenuTitle="직원관리" varPageTitle="업무일지상세" />
      {isObjEmpty(varStaffReportInfo)?null:
        <div className="admin-content">
          <div className="main-box">
            <table className="write">
              <colgroup>
                <col width="20%"/><col width="20%"/>
                <col width="15%"/><col width="15%"/>
                <col width="15%"/><col width="15%"/>
              </colgroup>
              <thead></thead>
              <tbody>
                <tr>
                  <th>아이디</th>
                  <td>{varStaffReportInfo.mem_id}</td>
                  <th>부서</th>
                  <td>{varStaffReportInfo.vd_name}</td>
                  <th>직위</th>
                  <td>{varStaffReportInfo.vp_name}</td>
                </tr>
                <tr>
                  <th>작성자</th>
                  <td>{varStaffReportInfo.mem_name}</td>
                  <th>등록일자</th>
                  <td colSpan={3}>{ChangeDateStringOnlyDate(varStaffReportInfo.sr_date)}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <h3>- 업무일지</h3>
          <div className="main-box">
            <table className="write">
              <colgroup><col width="20%"/><col width="80%"/></colgroup>
              <thead></thead>
              <tbody>
                <tr>
                  <th>업무요약</th>
                  <td>{unescapeHtml(varStaffReportInfo.sr_summary)}</td>
                </tr>
                <tr>
                  <th>업무내용</th>
                  <td>{unescapeHtml(varStaffReportInfo.sr_comment)}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="btn-center">
            <Link to={`/Admin/StaffReportList`} className="btn-danger">목록</Link>
          </div>
        </div>
      }
    </div>   
  );

}
export default StaffReportDetail;